import { render, staticRenderFns } from "./ClaimsPaidAndLossRes.vue?vue&type=template&id=28b12a10&"
import script from "./ClaimsPaidAndLossRes.vue?vue&type=script&lang=js&"
export * from "./ClaimsPaidAndLossRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports